// extracted by mini-css-extract-plugin
export default {"projectsBlock":"Projects_projectsBlock__Isd8q","projectsContainer":"Projects_projectsContainer__HMlQf","projects":"Projects_projects__HL-JN"};